import React from 'react';
import Home from './Routes/Home';

function App() {
  return <Home />;
}

export default App;
